import styled from "styled-components";

interface SmallDetect {
  small?: boolean;
}

export const Avatar = styled.img<SmallDetect>`
  height: ${(p) => (p.small ? "40px" : "50px")};
  width: ${(p) => (p.small ? "40px" : "50px")};
  aspect-ratio: 1;
  margin-left: 10px;
  border-radius: 50px;

  flex-shrink: 0;

  font-size: 0px;
`;

export const Badge = styled.div`
  height: 4px;
  width: 4px;
  position: fixed;
  background-color: #f00;
  border-radius: 15px;
`;

export const Logo = styled.img`
  height: 60px;
`;
